import type { TargetableClass } from '@feathr/blackbox';

/**
 * Option representation for the geofilter set dropdown.
 */
export interface IGeoFilterSetOption {
  id: string;
  _cls: TargetableClass.geo_set;
  name: string;
  is_default?: boolean;
  included_geo_filters: string[];
  excluded_geo_filters: string[];
}

/**
 * Sorts geofilter set options with defaults first, then alphabetically by name.
 *
 * @param options - Array of geofilter set options to sort
 * @returns New sorted array
 *
 * @example
 * const sorted = sortGeoFilterSets(options);
 * // Default sets appear first, then alphabetical
 */
export function sortGeoFilterSets(options: IGeoFilterSetOption[]): IGeoFilterSetOption[] {
  return [...options].sort((a, b) => {
    if (a.is_default && !b.is_default) {
      return -1;
    }
    if (!a.is_default && b.is_default) {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });
}

/**
 * Gets the label for a geofilter set option.
 *
 * @param option - The geofilter set option
 * @returns The option's name
 */
export function getOptionLabel(option: IGeoFilterSetOption): string {
  return option.name;
}
